// src/appointments.ts
var APPOINTMENT_STATUSES = [
  "scheduled",
  "confirmed",
  "in_progress",
  "completed",
  "cancelled",
  "no_show"
];

export {
  APPOINTMENT_STATUSES
};
